import type {
  PortalAccessAdminSnapshot,
  PortalRoleAdminSnapshot,
  PortalRolePrincipalSearchResult,
  PortalStationAccessRole,
  PortalUserContext,
  PortalAccessStatus,
  PortalUsageRange,
  PortalUsageSnapshot
} from "../../shared/types";
import type { PortalAccessOverview } from "../../shared/types";
import { deleteRequired, getRequired, patchRequired, postRequired } from "./apiClient";

export function getPortalContext(): Promise<PortalUserContext> {
  return getRequired("/me");
}

export function searchAccessOverviewUsers(query: string): Promise<PortalRolePrincipalSearchResult> {
  return getRequired(`/admin/portal-access/overview/users?q=${encodeURIComponent(query)}`);
}

export function getAccessOverview(id: string): Promise<PortalAccessOverview> {
  return getRequired(`/admin/portal-access/overview/users/${encodeURIComponent(id)}`);
}

export function getPortalAccessAdminSnapshot(): Promise<PortalAccessAdminSnapshot> {
  return getRequired("/admin/portal-access");
}

export function updatePortalUserStatus(
  entraObjectId: string,
  accessStatus: Exclude<PortalAccessStatus, "SETUP_REQUIRED">
): Promise<PortalAccessAdminSnapshot> {
  return patchRequired(`/admin/portal-access/users/${encodeURIComponent(entraObjectId)}/status`, { accessStatus });
}

export function grantPortalStationAccess(
  entraObjectId: string,
  stationSks: number[],
  accessRole: PortalStationAccessRole
): Promise<PortalAccessAdminSnapshot> {
  return postRequired(`/admin/portal-access/users/${encodeURIComponent(entraObjectId)}/stations`, { stationSks, accessRole });
}

export function revokePortalStationAccess(entraObjectId: string, accessId: string): Promise<PortalAccessAdminSnapshot> {
  return deleteRequired(`/admin/portal-access/users/${encodeURIComponent(entraObjectId)}/stations/${encodeURIComponent(accessId)}`);
}

export function getPortalRoleAdminSnapshot(): Promise<PortalRoleAdminSnapshot> {
  return getRequired("/admin/portal-access/app-roles");
}

export function getPortalUsageSnapshot(range: PortalUsageRange, refresh = false): Promise<PortalUsageSnapshot> {
  const params = new URLSearchParams({ range });
  if (refresh) {
    params.set("refresh", "true");
  }
  return getRequired(`/admin/portal-access/usage?${params.toString()}`);
}

export function searchPortalRolePrincipals(query: string, type?: "User" | "Group"): Promise<PortalRolePrincipalSearchResult> {
  return getRequired(`/admin/portal-access/app-roles/principals?query=${encodeURIComponent(query)}${type ? `&type=${type}` : ""}`);
}

export function grantPortalAppRole(principalId: string, appRoleId: string): Promise<PortalRoleAdminSnapshot> {
  return postRequired("/admin/portal-access/app-roles/assignments", { principalId, appRoleId });
}

export function revokePortalAppRoleAssignment(assignmentId: string): Promise<PortalRoleAdminSnapshot> {
  return deleteRequired(`/admin/portal-access/app-roles/assignments/${encodeURIComponent(assignmentId)}`);
}
